import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FilelistAudienceSeating.html?raw';
import '../../../../moreCore/UI/DateTimeInput/DateTimeInput';
import '../../../../moreCore/UI/Edit/Edit';
import '../../../../moreCore/UI/CheckBox/CheckBox';
import '../../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../../moreCore/UI/SearchSelect/SearchSelect";
import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../../_loadingHelpers/VAMv2Types";
import EntityStore from '../../../../moreCore/Tools/EntityStore';
import FileUpload from '../../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
//import FileUploadDisplay_ListRow = require("../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow");
import { FileUploadTypes } from "../../../../moreCore/UI/Filetransfer/FileUpload/FileUploadTypes";
import PageStack from '../../../../moreCore/UI/Tabbing/PageStack';
import "../../../../moreCore/UI/Tabbing/PageStack";
import Tooltip from '../../../../moreCore/UI/Floating/Tooltip';


interface HtFile {
    ID: string;
    Classname: string;
    filename: string
    fileID: string
}
class FilelistAudienceSeating extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    //private fileCategories: Array<{ ID: string, description: string }> = [];
    private bookingFilesTableContainer: HTMLElement;
    //private newUploadFiles: Array<VAM2types.FileUploadWithCategories> = [];

    private pagestack: MdsLax<InstanceType<typeof PageStack>>;

    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.VtFiles | VAM2types.FileUploadWithCategories>>>;
    private entityId: string;
    private entitylist: Array<VAM2types.VtFiles>;

    private uploadedFiles: Array<FileUploadTypes.UploadUnit>
    private removedFiles: Array<string> = [];

  
    existingFilesTableLayout: StaticTable.RowConfig = {
        "attributes": ["filename", "keyword", "ref_file_category.description", "ref_entity_1.$ClassPrintname"],
        colNamesInternal: ["filename", "keyword", "ref_file_category.description", "Source"],
        "colspans": [1, 1, 1, 1],
        "headings": ["General_Label_Filename","General_Label_Keyword", "General_Label_Category", "General_Label_Source"],
        widths: [null, null, null, "15ch"],
        alignmentsHeading: [null, null, null, null],
        alignmentsRow: [null, null, null, null]
    };

    private table_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.VtFiles>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        console.log(colName);

        switch (colName) {
            case "Source":
                let sourceTooltip = new Tooltip();
                let fileEntity = entity as any;
                if (fileEntity && fileEntity.ref_entity_1) {
                    sourceTooltip.setup({
                        content: fileEntity.ref_entity_1?.$Displayname,
                        targetnode: node,
                        enableHover: true,
                        enableClick: true,
                        heading: value
                    });
                    node.innerHTML = this.createFontawesomeIcon("fas fa-info-circle", "&nbsp;").outerHTML + value;
                    return true;
                }
                else {
                    cell.value = null;
                    return false;
                }
                break;
        }

        return false;
    }

    private _emitHandle: any = null;
    private _onChange_StoreData() {
        let diffData = this.store.getDiffData();
        let completeList = this.store.getCurrentCompleteList();


        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.uploadedFiles), 100);
    }
    

    getData(): EntityStoreData<VAM2types.VtFiles> {
        let data: EntityStoreData<VAM2types.VtFiles> = {
            changed: [],
            deleted: [],
            new: []
        };

        let storeData = this.store.getDiffData();

        //data.new = this.uploadedFiles as any;
        data.new = this.fileUpload.getValue() as any;

        data.deleted = storeData.deleted;
        data.changed = storeData.changed as any;

        return data;
    }
    private enableActionButtonsForFile(file, rowGroup: StaticTable.StaticTableRowGroup<any>): boolean {

        return file.Classname === "ht_files"
    }
    private setupTable(): void {
        //Files_Edit
        this.tableContainer.innerHTML = null;
       

        this.table = new StaticTable();
        
        this.table.addDefaultRowActionButton("delete", lang.hitch(this, this._onRowDeleting), lang.hitch(this, this.enableActionButtonsForFile), false);//, ;
        this.table.addCustomRowActionButton("download", lang.hitch(this, this._downloadFile), "fas fa-download", null, null, null, lang.hitch(this, this.enableActionButtonsForFile), false);
        this.table.setFormatter(this.table_formatterFunction);
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);

        this.table.addLineConfig(this.existingFilesTableLayout);
        this.table.setCyAttribute("FilelistAudienceSeatingTable");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);

        //this.table.enableActionButton("delete", null, false);

        let list = this.store.getCurrentCompleteList("existing");

        for (let entry of list) {
            this.webPrivilegeManager.loadPrivilegesForEntity(entry, lang.hitch(this, this._onEntityPrivilegeReady, entry));
        }
    }

    private _onEntityPrivilegeReady(file: VAM2types.VtFiles) {
        if (!file["Classname"]) return;
        this.hasUserRole("Files_Delete", lang.hitch(this, this._onDeletePrivilege, file), file);        
    }
    private _onDeletePrivilege(file: VAM2types.VtFiles, hasPrivilege: boolean) {
        this.table.enableActionButton("delete", file, hasPrivilege);

    }
    
    
    //private extendFileupload(uploadData: FileUploadTypes.FileUploadData_Stump): VAM2types.FileUploadWithCategories {

    //    let pseudoFiles = [];
    //    let count = 0;
    //    let exFile: VAM2types.FileUploadWithCategories = {
    //        ...uploadData,
    //        fileCategories: [],
    //    }
    //    for (let filename of uploadData.filenames) {
    //        exFile.fileCategories.push({
    //            category: this.fileCategories[0].ID,
    //            fileName: filename
    //        })
    //    };


    //    return exFile;
    //}

    private _onRemovedUpload(removedFile: FileUploadTypes.UploadDescriptor) {

        // TODO: Pseudoentry im Store finden (! mit guid und count nicht möglich, weils ja gerade entfernt worden ist!!) und entfernen,
        // damit sich die Liste neu zeichnet.
        var currentCompleteList = this.store.getCurrentCompleteList();
        var listItem:VAM2types.VtFiles;
        for (listItem as any of currentCompleteList) {
            if (listItem.ID.match(removedFile.uploadGUID)) {
                this.store.deleteEntry(listItem);
            }
        }
        //// Liste der Uploads aktualisieren:
        //for (let i = 0; i < this.uploadedFiles.length; i++) {
        //    let upload = this.uploadedFiles[i];
        //    if (removedFile.uploadGUID == upload.guid) {
        //        this.uploadedFiles.splice(i, 1);

        //        this._onChange_StoreData();

        //        this._onChangeUploadFile();
        //        return;
        //    }
        //}
    }

    private _onRowDeleting(data): void {
        var entity = data.entity;
        if (entity.ID.match("__")) {
            var guid = data.entity.ID.split("__")[0];
            var filename = data.entity.filename;
            this.fileUpload.removeUploadedFile(guid, filename);
        }
    }


    private _onChangeUploadFile() {
        let newFilesData = this.fileUpload.getValue();
        
        if (newFilesData && this.fileUpload.validateInput()) {

            newFilesData.forEach(file => {

                let guid = file.guid;
                let fileNames = file.filenames

                let existingFile = this.store.getEntityById(guid);
                if (!existingFile) {
                    //let exfile = this.extendFileupload(file);

                    this.uploadedFiles.push(file);
                    this.store.addEntry({ ID: file.guid, filename: file.filenames.length > 1 ? this.getMoreNamesString(file.filenames) : file.filenames[0] });
                //    let count = 0;
                //    for (let filename of file.filenames) {
                //        count++;
                //        let pseudofile: VAM2types.VtFiles = {
                //            filename: filename,
                //            //ref_file_category: this.fileCategories[0],
                //            ID: file.guid + "__" + count,
                            
                //        }
                //        this.store.addEntry(pseudofile);
                //    }
                }
            });

            
        } else {

        }
    }
    private getMoreNamesString(names: Array<string>) : string {
        let finalString : string;

        finalString = names.join(", ");
        if (finalString.length > 16) {
            finalString = finalString.slice(0, 16) + '[...]';
        }
        return finalString;
    }

    //private _loadFileCategoriesList(): void {

    //    let requestUrl = window.appRoot + "EvBookingEditor/GetFileCategoriesList";

    //    this.RequestManager.post(
    //        requestUrl,
    //        {
    //            jsonData: null
    //        },
    //        (response: any) => { this.fileCategories = response },
    //        (err: any) => { alert(err.Message) },
    //        false // sync
    //    );
    //}

    //protected _onUploadRowCreated(evt: { name: string, row: FileUploadDisplay_ListRow }): void {
    //    let fileRow = evt.row;

    //    let selectBox = new SearchSelect();

    //    selectBox.labelAttribute = "description";
    //    selectBox.setLabel(this.translations["General_Label_Category"]);
    //    selectBox.setSelectionListLEGACY(this.fileCategories);

    //    let categoryToSet = this.fileCategories[0].ID;

    //    selectBox.on("change", lang.hitch(this, this.assignCategoryToNewFile, fileRow, selectBox));

    //    selectBox.setValue(categoryToSet);

    //    fileRow.setSecondElementInFileRow(true, selectBox.domNode);
    //}

    //private assignCategoryToNewFile(fileRow: FileUploadDisplay_ListRow, categorySelect: SearchSelect, value: string): void {

    //    let file = fileRow.getData();
    //    let rowFileGuid = file.uploadGUID
    //    let rowFileName = file.filename;

    //    let targetUpload: VAM2types.FileUploadWithCategories = null;
    //    for (let upload of this.uploadedFiles) {
    //        if (rowFileGuid == upload.guid) {
    //            targetUpload = upload;
    //            break;
    //        }
    //    }

    //    let selectedCategory = categorySelect.getValue(true) as { ID: string, description: string };

    //    //if (fileToSave) fileToSave["fileCategoryID"] = value;
    //    if (targetUpload) {
    //        for (let categoryAssignment of targetUpload.fileCategories) {
    //            let count = 0;
    //            if (categoryAssignment.fileName == rowFileName) {
    //                count++;
    //                categoryAssignment.category = selectedCategory.ID;

    //                this.store.setEntityAttributeValue(rowFileGuid + "__" + count, "ref_file_category", selectedCategory);

    //            }
    //        }
    //    }
    //}

    private _downloadFile(file: StaticTable.StaticTableRowGroup<HtFile>): void {
        if (file.entity.Classname) {
            window.open(window.appRoot + `Downloads/DownloadFile?downloadKey=${file.entity.fileID}`);
        } else {
            this.showToast(this.translate("General_Error_FileNotUploaded"), "fas fa-exclamation-triangle");
        }
    }

    setup(existingFiles: Array<VAM2types.VtFiles>, deletedFiles = [], newFiles = [], entityId: string = null) {

        this.entitylist = [];
        this.removedFiles = deletedFiles;
        for (let file of existingFiles) {
            if (this.removedFiles.indexOf(file.ID) == -1) this.entitylist.push(file);
        }

        for (let file of newFiles) {
            this.entitylist.push({ ID: file.guid, filename: file.filenames.length > 1 ? this.getMoreNamesString(file.filenames) : file.filenames[0] });
        }
        this.store.setup(this.entitylist, "ID");
        
        this.entityId = entityId;

        this.uploadedFiles = newFiles;
        this.setupTable();

        this.fileUpload.resetFileUpload();
        if (/*this.uploadedFiles*/ newFiles.length > 0) {
            this.fileUpload.loadFileUploadFromData(/*this.uploadedFiles*/ newFiles);
        }
        this.uploadedFiles = [];
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (!this.hasFeature("MainCatalog/AudienceSeatingLayoutsFiles")) return;

        this.useStandbyManager = true;

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.fileUpload.on("complete_remove", lang.hitch(this, this._onRemovedUpload))
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        if (!this.hasFeature("MainCatalog/AudienceSeatingLayoutsFiles")) return;
        //this._loadFileCategoriesList();

        //this.fileUpload.on("NewRowCreated", lang.hitch(this, this._onUploadRowCreated));
        //this._loadFileCategoriesList();

        this.pagestack.showPage("upload");
        this.pagestack.activatePageByName("files_default");        
    }
}

export default mdsWidget(FilelistAudienceSeating);